import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { PlanGuard } from '../guards/plan.guard';
import { AppService } from '../app.service';
import { SsspListComponent } from './sssp-list/sssp-list.component';

const routes: Routes = [
  {
    path: 'sssp',
    component: SsspListComponent,
    canActivate: [
      AuthGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.SAFETY_PLANS }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SsspRoutingModule { }
